import { render, staticRenderFns } from "./download_win.vue?vue&type=template&id=ca45a556&scoped=true&"
import script from "./download_win.vue?vue&type=script&lang=js&"
export * from "./download_win.vue?vue&type=script&lang=js&"
import style0 from "./download_win.vue?vue&type=style&index=0&id=ca45a556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca45a556",
  null
  
)

export default component.exports